import { Box, IconButton, Typography, Snackbar } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Header from '../../components/Header';
import { DataContext } from '../../contexts/DataContext';
import PrimaryButton from '../../components/PrimaryButton';
import FloatingActions from '../../components/FloatingActions';
import { useNavigate } from 'react-router-dom';
import { useFlow } from '../../contexts/FlowContext';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';

function CouponPage(props) {
  const { onFinish } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getBasePath } = useFlow();
  const { data,trackEvent } = useContext(DataContext);
  const [showCopyTooltip, setShowCopyTooltip] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(data?.coupon || '');
    setShowCopyTooltip(true);
  };

  const handleTooltipClose = () => {
    setShowCopyTooltip(false);
  };
    useEffect(() => {
      trackEvent({ nav_to_your_devices: 1 });
    }, [trackEvent]);

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
        overflowY: 'auto',
        position: 'relative',
      }}
    >
      <Header steps={0} currentStep={0} />

      <div
        style={{
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'column',
          paddingInline: '24px',
          alignItems: 'stretch',
          textAlign: 'left',
          height: 'calc(100% + 40px)',
        }}
      >
        <div
          style={{
            background: 'white',
            borderRadius: '4px',
            padding: '16px',
            paddingTop: '21px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'space-between',
            gap: '0px',
          }}
        >
          <Typography
            sx={{
              fontSize: '24px',
              fontWeight: '500',
              lineHeight: '29.805px',
              color: '#44546A',
            }}
          >
            {t('4.couponPage.title')}
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: '500',
              marginTop: '8px',
              opacity: '0.5',
              color: '#44546A',
            }}
          >
            {t('4.couponPage.description')}
          </Typography>
          <div
            style={{
              borderTop: '4px dashed #F6F4F0',
              marginTop: '23px',
              paddingTop: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                position: 'relative',
                color: '#44546A',
                fontSize: '32px',
                fontWeight: '500',
                background: '#F6F4F0',
                borderRadius: '4px',
                height: '56px',
                width: '100%',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {data?.coupon}
              {false &&<IconButton
                onClick={handleCopyClick}
                sx={{
                  position: 'absolute',
                  right: '60px',
                  height: '45px',
                  width: '45px',
                  backgroundColor: 'transparent',
                }}
              >
                <ContentCopyIcon style={{ color: '#44546A', height: '45px' }} />
              </IconButton>}
            </div>
          </div>
        </div>
      </div>

      <FloatingActions childrenStyle={{}}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
            paddingInline: '24px',
          }}
        >
          <PrimaryButton
            style={{ flex: 1 }}
            onClick={() => onFinish()}
          >
            {t('finish')}
          </PrimaryButton>
        </div>
      </FloatingActions>

    {false &&<Snackbar
      open={showCopyTooltip}
      autoHideDuration={2000}
      onClose={handleTooltipClose}
      message={t('4.couponPage.copied') || 'Copied!'}
      anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
      sx={{
        width: '120px',
        borderRadius: '20px',

        '& .MuiSnackbarContent-root': {
          backgroundColor: 'rgb(68, 84, 106,0.5)',
          color: 'white',
          fontSize: '14px',
          borderRadius: '4px',
          width: '100%',
          textAlign: 'center',
          justifyContent: 'center',
          minHeight: 'auto',
        },
      }}
    />}
    </Box>
  );
}

export default CouponPage;
